import "./App.css";
import { RenderRoutes } from "./Router/RenderRoutes";
import { Amplify } from "aws-amplify";
import { CustomTheme } from "ThemeCustom";
import { ConfigProvider, message } from "antd";
import { useEffect } from "react";
import { getAccountDetails } from "Sdk/Actions";
import { useSelector } from "react-redux";
import {
  getTokenFromReducer,
  getUserNameFromReducer,
} from "Store/reducers/Auth/AuthSlice";
import awsExports from "./aws-exports";
import {
  getCombinedOAuthErrorStringFromWindow,
  getFederatedSignInFailureUserMessage,
  isAccountLinkedOAuthError,
  shouldShowAccountLinkedUiToast,
} from "./Utility/authErrors";

const getRedirectUrl = () => {
  const hostname = window.location.hostname;

  if (hostname === "localhost") return "http://localhost:3000/";
  if (hostname === "stage.inprofile.co") return "https://stage.inprofile.co/";
  if (hostname === "admin.inprofile.co") return "https://admin.inprofile.co/";
  if (hostname === "inprofile.co" || hostname === "www.inprofile.co") {
    return `${window.location.origin}/`;
  }

  // fallback
  return "https://d2i1ogulq0ls8x.cloudfront.net/";
};

const updatedConfig = {
  ...awsExports,
  oauth: {
    ...awsExports.oauth,
    redirectSignIn: getRedirectUrl(),
    redirectSignOut: getRedirectUrl(),
  },
};

Amplify.configure(updatedConfig);

function App() {
  const userName = useSelector(getUserNameFromReducer);
  const token = useSelector(getTokenFromReducer);

  useEffect(() => {
    const oauthErr = getCombinedOAuthErrorStringFromWindow();
    if (
      oauthErr &&
      isAccountLinkedOAuthError(oauthErr) &&
      shouldShowAccountLinkedUiToast()
    ) {
      message.info(getFederatedSignInFailureUserMessage(oauthErr), 8);
    }
  }, []);

  useEffect(() => {
    const fetchUserDetails = async () => {
      await getAccountDetails(userName);
    };
    if (token && userName) {
      fetchUserDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, userName]);

  return (
    <ConfigProvider theme={CustomTheme}>
      <RenderRoutes />
    </ConfigProvider>
  );
}

export default App;
